import React from "react";
import { Link } from "react-router-dom";
import homeIcon from "../assets/home.webp";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = "" }) => {
  return (
    <div className={`w-full py-2 ${className}`}>
      <div className="px-5 max-w-[1710px] w-full bg-[#fff] m-auto min-h-[24px]">
        <nav className="flex items-center space-x-2 text-sm">
          {/* Home Icon */}
          <Link
            to="/"
            className="text-[#8E8E8E] transition-colors duration-200"
            aria-label="Home"
          >
            <img src={homeIcon} alt="Home" className="w-4 h-4" />
          </Link>

          {/* Breadcrumb Items */}
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <FontAwesomeIcon icon={faChevronRight} className="text-[10px] text-[#333] font-bold" />
              {/* <span className="text-[#333]">/</span> */}
              {index === items.length - 1 ? (
                <span className="text-[#333] font-normal text-[12px]">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="text-[#333] transition-colors duration-200"
                >
                  {item.label}
                </Link>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Breadcrumbs;
